export const FrontLoginRoutes = [] as JSX.Element[];
